import './ssasanantzoo/style';
import FormStructure from './ssasanantzoo/form_structure';

export default FormStructure;